import React, { useState } from "react";
import PropTypes from "prop-types";
import { Popover, ArrowContainer } from "react-tiny-popover";

const PopOver = ({ className = "", children = null, content = "" }) => {
    const classes = `popover ${className}`;
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);

    return (
        <div className={classes}>
            <Popover
                isOpen={isPopoverOpen}
                positions={["top", "right", "left", "bottom"]}
                padding={1}
                onClickOutside={() => setIsPopoverOpen(false)}
                content={({ position, childRect, popoverRect }) => (
                    <ArrowContainer
                        position={position}
                        childRect={childRect}
                        popoverRect={popoverRect}
                        arrowSize={10}
                        arrowStyle={{ opacity: 0.7 }}
                        className="popover-arrow-container"
                        arrowClassName="popover-arrow"
                    >
                        <div className="pop-over-content" onClick={() => setIsPopoverOpen(!isPopoverOpen)}>
                            {content}
                        </div>
                    </ArrowContainer>
                )}
            >
                <button onClick={() => setIsPopoverOpen(!isPopoverOpen)} className="popover-btn">{children}</button>
            </Popover>
        </div>
    );
};

PopOver.propTypes = {
    className: PropTypes.string,
    children: PropTypes.object,
    content: PropTypes.string,
};

export default PopOver;
